import {
    Linear,
    MediaFile,
    Creative,
    AbstractAd,
} from '@lib/iab/iab-vast-model';

export interface AdData {
    linear: Linear;
    creative: Creative;
    ad: AbstractAd;
    mediaFile: MediaFile;
    duration: number;
    skipOffset: number | null;
    clickThroughUrl: string | null;
    clickTrackingUrls: string[];
    impressionUrls: string[];
    trackingEvents: Map<string, string[]>;
    adTitle: string | null;
    advertiser: string | null;
    errors: string[] | null;
}

export type VastPluginOptions = {
    url: string;
    autoplay?: boolean;
    skipOffset?: number;
    timeout?: number | null;
    debug?: boolean;
    onAdLoaded?: (ad: AdData) => void;
    onAdStart?: (ad: AdData) => void;
    onAdEnd?: () => void;
    onAdError?: (error: Error) => void;
    onAdClick?: (clickUrl: string) => void;
    onEvent?: (eventName: TrackingEventName) => void;
};

export const VideoEventNames = [
    'loaded',
    'start',
    'pause',
    'resume',
    'mute',
    'unmute',
    'skip',
    'closeLinear',
    'progress',
] as const;

export type VideoEventName = (typeof VideoEventNames)[number];

export const ProgressEventNames = [
    'firstQuartile',
    'midpoint',
    'thirdQuartile',
    'complete',
] as const;

export type ProgressEventName = (typeof ProgressEventNames)[number];

export type TrackingEventName = VideoEventName | ProgressEventName;
